import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabaseClient';

function PlatformPresence() {
  const { user, isAuthenticated, emailConfirmed } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !emailConfirmed || !user?.id) return undefined;

    const updateLastSeen = () => {
      supabase
        .from('profiles')
        .update({ last_seen_at: new Date().toISOString() })
        .eq('id', user.id)
        .then(({ error }) => {
          if (error) console.error('Unable to update last seen:', error);
        });
    };

    updateLastSeen();
    const timer = window.setInterval(updateLastSeen, 30000);
    const updateOnFocus = () => updateLastSeen();
    const updateOnVisibilityChange = () => {
      if (document.visibilityState === 'visible') updateLastSeen();
    };
    window.addEventListener('focus', updateOnFocus);
    document.addEventListener('visibilitychange', updateOnVisibilityChange);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', updateOnFocus);
      document.removeEventListener('visibilitychange', updateOnVisibilityChange);
    };
  }, [user?.id, isAuthenticated, emailConfirmed]);

  return null;
}

export default PlatformPresence;
